import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import Iconify from '@iconify/iconify';
/**
 * Only the icons this app actually renders.
 *
 * Importing the full `@iconify-json/{solar,tabler,ic}/icons.json` here put
 * 12.7 MB of icon data (24 394 icons) into the initial bundle — a source-map
 * breakdown of `main.js` showed 97 % of its 12.2 MB was those three files, paid
 * on every page load before Angular booted. The subset holds the 93 icons the
 * source references and weighs 62 kB.
 *
 * Generated — do not edit by hand. After adding an icon to a template or a TS
 * literal, run `npm run generate:icons` and commit the result.
 */
import iconifySubset from './app/core/icons/iconify-subset.json';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import type { IconifyJSON } from '@iconify/types';

for (const collection of iconifySubset as IconifyJSON[]) {
  Iconify.addCollection(collection);
}

registerLocaleData(localeFr);

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...appConfig.providers || [],
    providePrimeNG({
      theme: {
        preset: Aura
      }
    })
  ]
}).catch((err) =>
  console.error(err)
);